var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "27181BC1-A3E6-4FD3-955E-931F19858B4A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.070588 0 0 0 0 0.415686 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Campaign_16.1",
    transform: "translate(-1224.000000, -734.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy",
    transform: "translate(1215.000000, 521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-Copy",
    transform: "translate(9.210526, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill-Copy-4",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.41964,18.6098 L17.49264,14.69204 C17.47284,14.67224 17.44952,14.65772 17.42884,14.64364 C17.07596,15.18616 16.654,15.70184 16.17792,16.17792 C15.70228,16.654 15.18572,17.07596 14.63748,17.42972 C14.65684,17.44996 14.67136,17.47372 14.69116,17.49308 L18.61024,21.41964 C19.38596,22.19404 20.64568,22.19316 21.41876,21.41964 C22.19272,20.64524 22.19316,19.38508 21.41964,18.6098 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.61824,2.67476 C12.05072,-0.89188 6.24712,-0.89188 2.67916,2.67564 C-0.89232,6.24228 -0.89276,12.05028 2.67652,15.61824 C6.2458,19.18444 12.05072,19.18444 15.61824,15.6178 C19.18576,12.05028 19.18532,6.24184 15.61824,2.67476 Z M4.3582,13.93832 C1.71688,11.297 1.71776,6.99688 4.35908,4.3582 C7.0004,1.71732 11.29788,1.71732 13.93832,4.35688 C16.57788,6.99688 16.577,11.29216 13.93832,13.93744 C11.29744,16.5704 7.0004,16.58008 4.3582,13.93832 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2392,9.88416 C6.04516,9.08688 5.24612,7.98072 4.5738,8.33316 C4.04096,8.60508 4.191,9.85204 4.44224,10.58948 C5.56512,13.94272 9.64876,14.65156 10.07336,14.2274 C10.49092,13.81028 7.00832,13.0394 6.2392,9.88416 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.0cd67cc8bf6f547fecf36ff87b8f4691.svg";
export { ForwardRef as ReactComponent };